import LoadingComponent from '@/pages/components/loadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/honourKnight/home/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/honourKnight/home',
    exact: true,
    meta: {
      title: '荣耀骑士'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/honourKnight/record/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/honourKnight/record',
    exact: true,
    meta: {
      title: '荣耀骑士进出记录'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/honourKnight/explain/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/honourKnight/explain',
    exact: true,
    meta: {
      title: '荣耀骑士说明'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/honourKnight/knightRankingList/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/honourKnight/knightRankingList',
    meta: {
      title: '荣耀骑士榜'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/honourKnight/attendScoreRecord/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/honourKnight/attendScoreRecord',
    meta: {
      title: '出勤分分数记录'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/honourKnight/taskList/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/honourKnight/taskList',
    meta: {
      title: '出勤任务列表'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/honourKnight/attendScoreRule/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/honourKnight/attendScoreRule',
    meta: {
      title: '出勤分规则'
    }
  }
]
